// src/redux/api/packages.js
import { apiSlice } from ".";
import { toast } from "react-toastify";

const packagesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPackagesDetails: builder.query({
     query: (countryId) => ({
    url: `/Packages/GetPackagesDetails?countryid=${countryId}`,
    method: "GET",
  }),
    }),
   postAgencyPkgDetails: builder.mutation({
  query: ({ agencyid, pkgid, purchaseSource, purchaseDate }) => ({
    url: "/Packages/PostAgencyPkgDetails",
    method: "POST",
    body: { agencyid, pkgid, purchaseSource, purchaseDate },
  }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Selecting package...",
          success: "Package selected successfully ✅",
          error: "Error selecting package ❌",
        });
      },
    }),
    updatePackage: builder.mutation({
      query: ({ agencyId, packageId }) => ({
        url: "/Packages/UpdatePackage",
        method: "PUT",
        body: { agencyId, packageId },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Updating package...",
          success: "Package updated successfully ✅",
          error: "Error updating package ❌",
        });
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPackagesDetailsQuery,
  usePostAgencyPkgDetailsMutation,
  useUpdatePackageMutation,
} = packagesApi;